import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_PRODUCT_GROUPS_QUERY = queryWithFallbackKey(
    gql`
        query getProductGroupListing($defaultLanguage: String!) {
            getObjectFolder(
                fullpath: "/Resource Library/Categorization/Product Hierarchy"
                defaultLanguage: $defaultLanguage
            ) {
                children {
                    ... on object_ProductGroup {
                        id
                        key
                        name
                        shortBlurb
                        longBlurb
                        dmDefinitionId
                        image {
                            image {
                                fullpath
                            }
                        }
                        backgroundImage {
                            image {
                                fullpath
                            }
                        }
                        hubspotYageoContactUs_enabled: hubspotYageoContactUs_productGroup_enabled
                        hubspotYageoContactUs_fieldValue: hubspotYageoContactUs_productGroup_fieldValue
                        hubspotYageoContactUs_subgroupFieldName: hubspotYageoContactUs_productGroup_subgroupFieldName
                        productSubgroups {
                            id
                            key
                            name
                            shortBlurb
                            longBlurb
                            dmDefinitionId
                            image {
                                image {
                                    fullpath
                                }
                            }
                            backgroundImage {
                                image {
                                    fullpath
                                }
                            }
                            hubspotYageoContactUs_enabled: hubspotYageoContactUs_productGroup_enabled
                            hubspotYageoContactUs_fieldValue: hubspotYageoContactUs_productGroup_fieldValue
                            hubspotYageoContactUs_subgroupFieldName: hubspotYageoContactUs_productGroup_subgroupFieldName
                        }
                    }
                }
            }
        }
    `,
    'GET_PRODUCT_GROUPS_QUERY'
);

export function getProductGroupQueryVariables(localeCode: LocaleCode) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
    };
}
